import {
  Row,
  Col,
  Tree,
  Modal,
  Table,
  Tooltip,
  Tabs,
  Select,
  Menu,
  Button,
  Spin,
  Input,
  Form
} from "antd";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";

import WeaAssociativeSearch from "../wea-associative-search";
import WeaBrowserSearch from "../../wea-browser-search";
import WeaTools from "../../wea-tools";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaFormItem from "../../wea-form-item";
import WeaSelect from "../../wea-select";
import data from "../wea-browser-icons/data";

const getLabel = WeaLocaleProvider.getLabel;

const doSort = (arr, key, order = 1) =>
  arr.sort((a, b) => {
    if (a[key] < b[key]) {
      return -order;
    } else if (a[key] > b[key]) {
      return order;
    }
    return 0;
  });

class Main extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: true,
      showDrop: false,
      paramKey: "",
      name: "",
      paramKeyCache: "",
      nameCache: "",
      dataCache: {},
      inputValue: "",
      count: 0,
      quickSearch: "",
      noData: false,
      selectedRowKeys: [],
      selectedId: "",
      selectList: [],
      separator: "_@"
    };
  }
  componentDidMount() {
    const { value, valueSpan } = this.props;
    let newState = {};
    if (!isEmpty(value) && valueSpan) {
      newState = { ...newState, paramKey: value, name: valueSpan };
    }
    // 默认显示数据
    if (!isEmpty(this.props.replaceDatas) && this.props.replaceDatas[0]) {
      const data = this.props.replaceDatas[0];
      let name = data.showName || data.paramName || data.name;
      let paramKey = data.id ? data.id + "" : "";
      let rowKeys = paramKey ? [paramKey] : [];
      newState = {
        ...newState,
        paramKey: paramKey,
        name: name,
        selectedRowKeys: rowKeys,
        paramKeyCache: paramKey,
        nameCache: name,
        dataCache: this.props.replaceDatas && data
      };
      // this.throwCurrentState(paramKey, name);
    }
    this.setState(newState);
    this.props.initFunc && this.props.initFunc(this);
  }
  componentWillReceiveProps(nextProps, nextState) {
    if ("value" in nextProps) {
      if (nextProps.value) {
        this.setState({
          paramKey: nextProps.value,
          name: nextProps.valueSpan,
          selectedRowKeys: [nextProps.value]
        });
        this.setState({
          paramKeyCache: nextProps.value,
          nameCache: nextProps.valueSpan,
          dataCache: nextProps.valueObj
        });
      } else {
        this.setState({ paramKey: "", name: "" });
        this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
      }
    }
    if ("visible" in nextProps && this.setState.visible !== nextProps.visible) {
      //form value改变&&有值
      this.setState({ visible: nextProps.visible });
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas) &&
      !nextProps.replaceNotCtrl
    ) {
      let paramKey = "",
        name = "";
      if (!isEmpty(nextProps.replaceDatas) && nextProps.replaceDatas[0]) {
        const data = nextProps.replaceDatas[0];
        name = data.showName || data.paramName || data.name;
        paramKey = data.id ? data.id + "" : "";
      } else {
        this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
      }
      this.setState({ paramKey: paramKey, name: name });
      this.setState({
        paramKeyCache: paramKey,
        nameCache: name,
        dataCache: nextProps.replaceDatas && data
      });
    }
  }

  initialState = (params = {}) => {
    // this.props.form && this.props.form.resetFields();
    const { needSelect } = this.props;
    if (needSelect == 1) {
      this.fetchSelect(params);
    } else {
      this.fetchData(params);
    }
  };
  fetchData(params = {}) {
    const { dataURL, dataParams, needSelect } = this.props;
    // const {pageSize} = this.state;
    let url = dataURL || "/api/integration/esb/service/returnsContextData";
    // param['min'] = 1;
    // param['max'] = 1 * pageSize;
    // param['pageSize'] = pageSize;
    params = {
      ...params,
      ...(needSelect ? dataParams : {})
    };
    url = `${url}?${WeaTools.getFd(params)}`;
    this.setState({ url });
    this.setLoading(true);
    WeaTools.callApi(url)
      .then(data => {
        if (data && data.length === 0) {
          this.setState({ noData: true });
        } else {
          this.setState({ noData: false });
        }

        // data = doSort(data, 'paramKey', -1);
        data.reverse();
        let treeData = [];
        let defaultExpandedRowKeys = [];
        const toYesOrNo = flag =>
          flag === "true" ? getLabel("163", "是") : getLabel("30587", "否");
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          element.arrs += "";
          element.required += "";
          element.arrs = toYesOrNo(element.arrs);
          element.required = toYesOrNo(element.required);
          // element.showName += `${selectedId ? `${separator}${selectedId}` : ''}`;
          defaultExpandedRowKeys.push(element.id);
          if (element.parentName) {
            for (let newIndex = index + 1; newIndex < data.length; newIndex++) {
              if (newIndex == data.length) {
                break;
              }
              const newElement = data[newIndex];
              if (newElement.paramKey === element.parentName) {
                if (
                  !newElement.children ||
                  typeof newElement.children !== "object"
                ) {
                  newElement.children = [];
                }
                newElement.children.unshift(element);
                break;
              }
            }
          } else {
            treeData.push(element);
          }
        }
        treeData.reverse();
        this.setLoading(false);
        this.setState({
          data: treeData,
          defaultExpandedRowKeys: defaultExpandedRowKeys
        });
      })
      .catch(e => this.props.onError && this.props.onError(e));
  }
  fetchSelect(params = {}) {
    const { selectUrl, dataParams = {}, replaceDatas } = this.props;
    const selectedId =
      Array.isArray(replaceDatas) && replaceDatas.length > 0
        ? replaceDatas[0].detail
          ? replaceDatas[0].detail.selectedId
          : this.getSelectedId(replaceDatas[0].name, true)
        : "";
    const url = selectUrl || "/api/integration/esb/publish/contextNodeOptions";
    WeaTools.callApi(
      `${url}?${WeaTools.getFd({ ...dataParams, selectedId })}`
    ).then(res => {
      if (res && res.data) {
        let newState = { selectList: res.data };
        let selectedOption;
        (res.data || []).forEach(option => {
          if (selectedId) {
            if (option.key === selectedId) {
              selectedOption = option;
            }
          } else if (option.selected) {
            selectedOption = option;
          }
        });
        if (selectedOption) {
          const { key, currentArray, contextType, supers } = selectedOption;
          params = {
            ...params,
            ...selectedOption.detail,
            selectedId: key,
            currentArray: currentArray,
            contextType: contextType,
            supers: supers ? JSON.stringify(supers) : ""
          };
          newState = { ...newState, selectedId: selectedOption.key };
        }
        this.setState(newState);
      }
      this.fetchData(params);
    });
  }
  setLoading(bool) {
    this.setState({ loading: bool });
  }

  showModal = bool => {
    this.setState({ visible: bool });
    if (bool) {
      this.props.onOpen && this.props.onOpen();
    } else {
      this.props.onClose && this.props.onClose();
    }
  };
  getSelectedId = (str = "", isId) => {
    const { replaceDatas } = this.props;
    const { separator, selectedId, selectList } = this.state;
    const index = str.indexOf(separator);
    let result;
    if (index !== -1) {
      result = isId
        ? str.substring(index).replace(separator, "")
        : str.substring(0, index);
    } else {
      result = isId ? "" : str;
    }
    if (!isId) {
      let selectedOption;
      (selectList || []).forEach(option => {
        if (selectedId) {
          if (option.key === selectedId) {
            selectedOption = option;
          }
        } else if (option.selected) {
          selectedOption = option;
        }
      });
      if (selectedOption) {
        const str = `(${selectedOption.showname})`;
        if (result.indexOf(str) == -1) {
          result = `${result}${str}`;
        }
      }
    }

    return result;
  };
  onBrowerClick = v => {
    this.setState({ browserConditions: [], inputValue: "" }, () => {
      this.initialState(); //初始化浏览框
      this.setState({ inputValue: "" });
      if (!isEmpty(v)) {
        this.setState({
          paramKeyCache: v[0].id,
          nameCache: v[0].showName || v[0].paramName || v[0].name,
          dataCache: v[0],
          selectedRowKeys: [v[0].id]
        });
      } else {
        this.setState({
          name: "",
          nameCache: "",
          paramKey: "",
          paramKeyCache: "",
          dataCache: {},
          selectedRowKeys: []
        });
      }
    });

    this.showModal(true);
  };
  onBrowerChangeHandler = (paramKey, name, data) => {
    this.throwCurrentState(paramKey, name, data);
  };

  throwCurrentState(paramKey = "", name, record) {
    const data = [];
    const { separator, selectedId } = this.state;
    const getName = str =>
      `${str}${selectedId ? `${separator}${selectedId}` : ""}`;
    name = name ? getName(name) : name;
    if (!Array.isArray(record)) {
      record = [record];
    }
    if (paramKey || name) {
      data.push({
        paramKey: paramKey.toString(),
        name
      });
    }
    this.props.onChange &&
      this.props.onChange(
        paramKey.toString(),
        name,
        record
          ? record.map(value => ({
              ...value,
              showName: getName(value.showName || value.paramName || value.name)
            }))
          : data
      );
  }

  onSearchChange = v => {
    this.setState({ inputValue: v });
    // TODO
  };
  topComponents = () => {
    const { inputValue } = this.state;
    return (
      <WeaBrowserSearch
        searchType={["base"]}
        searchsBaseValue={inputValue}
        onSearchChange={v => {
          this.setState({ inputValue: v });
        }}
        onSearch={this.onSearchChange.bind(this)}
      />
    );
  };
  handleOk = () => {
    const { paramKeyCache, nameCache, dataCache } = this.state;
    this.setState(
      {
        paramKey: paramKeyCache,
        name: nameCache,
        visible: false,
        url: "",
        selectedValue: "",
        contentType: ""
      },
      () => {
        this.throwCurrentState(paramKeyCache, nameCache, dataCache);
      }
    );
    this.showModal(false);
  };
  handleCancel = () => {
    this.setState({
      paramKeyCache: "",
      nameCache: "",
      dataCache: {},
      url: "",
      selectedValue: "",
      contentType: ""
    });
    this.showModal(false);
  };
  handleClear = () => {
    this.throwCurrentState("", "", "");
    this.setState({
      selectedValue: "",
      paramKeyCache: "",
      nameCache: "",
      dataCache: {},
      url: "",
      contentType: "",
      selectedRowKeys: []
    });
    this.showModal(false);
    this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
  };
  onRowClick(record, index) {
    if (typeof this.props.onRowClick === "function") {
      this.props.onRowClick(record, index);
    }
  }
  getColumns() {
    const defaultCol = [
      {
        title: getLabel("23481", "参数名称"),
        dataIndex: "paramName",
        key: "paramName",
        width: "26%"
      },
      {
        title: getLabel("30828", "显示名称"),
        dataIndex: "showName",
        key: "showName",
        width: "26%"
      },
      {
        title: getLabel("503477", "参数类别"),
        dataIndex: "paramType",
        key: "paramType",
        width: "16%"
      },
      {
        title: getLabel("514006", "必须"),
        dataIndex: "required",
        key: "required",
        width: "16%"
      },
      {
        title: getLabel("502118", "明细数据"),
        dataIndex: "arrs",
        key: "arrs",
        width: "16%"
      }
    ];
    return this.props.columns || defaultCol;
  }
  renderSelect() {
    const { selectedId, selectList } = this.state;
    return selectList && selectList.length > 0 ? (
      <WeaFormItem
        label={getLabel("511491", "上下文节点")}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 6 }}
        className="wea-nodetree-select"
      >
        <WeaSelect
          options={selectList}
          value={selectedId}
          onChange={(v, showname) => {
            const select = selectList.find(item => item.key === v);
            this.setState({ selectedId: v }, () => {
              if (select) {
                const { currentArray, contextType, supers } = select;
                this.fetchData({
                  ...select.detail,
                  selectedId: v,
                  currentArray: currentArray,
                  contextType: contextType,
                  supers: supers ? JSON.stringify(supers) : ""
                });
              }
            });
          }}
        />
      </WeaFormItem>
    ) : null;
  }
  renderData() {
    const {
      data,
      selectedRowKeys,
      defaultExpandedRowKeys
      // selectList,
      // selectedId
    } = this.state;
    const { isArray, contextType, contentHeight } = this.props;
    let isArrayStr = isArray + "";
    const toYesOrNo = flag =>
      flag === "true" ? getLabel("163", "是") : getLabel("30587", "否");
    isArrayStr = toYesOrNo(isArrayStr);
    // let contextType;
    // if (selectList && selectList.length) {
    //   const current = selectList.find(option =>
    //     selectedId ? option.key === selectedId : option.selected
    //   );
    //   if (current) {
    //     contextType = current.contextType;
    //   }
    // }
    const rowSelection = {
      selectedRowKeys: selectedRowKeys,
      type: "radio",
      onChange: (sRowKeys, sRows) => {
        this.setState({
          selectedRowKeys: sRowKeys,
          paramKeyCache: sRows[0] ? sRows[0].id : "",
          nameCache: sRows[0] ? sRows[0].showName || sRows[0].paramName : "",
          dataCache: sRows[0] ? sRows[0] : {}
        });
        if (typeof this.props.getSelection === "function") {
          this.props.getSelection(`${sRowKeys}`, sRows);
        }
      },
      getCheckboxProps: record => {
        return {
          disabled:
            contextType === "1"
              ? !record["check"]
              : record["arrs"] !== isArrayStr
        };
      }
    };
    return (
      <div>
        <Table
          scroll={{ y: (contentHeight || 460) - 44 }}
          rowSelection={rowSelection}
          columns={this.getColumns()}
          dataSource={data}
          defaultExpandedRowKeys={defaultExpandedRowKeys}
          // checkType={'radio'}
          rowKey={record => record.id}
          onRowClick={this.onRowClick.bind(this)}
          pagination={false}
        />
      </div>
    );
  }
  render() {
    const {
      icon,
      iconBgcolor,
      title,
      topPrefix,
      value,
      type,
      modalStyle,
      customized,
      hasRadio,
      buttons,
      noScroll = false
    } = this.props;
    const { paramKey, name, visible, contentType, loading } = this.state;
    const { quickSearch } = this.state;
    const showTop = quickSearch;
    const titleEle = (
      <Row>
        <Col span="22" style={{ paddingLeft: 20, lineHeight: "48px" }}>
          <div className="wea-browser-single-title">
            {iconBgcolor ? (
              <div
                className="wea-browser-single-icon-circle"
                style={{ background: iconBgcolor }}
              >
                <i className={icon} />
              </div>
            ) : (
              <span style={{ verticalAlign: "middle", marginRight: 10 }}>
                <i className={icon} />
              </span>
            )}
            <span style={{ verticalAlign: "middle" }}>
              {title || getLabel(511490, "选择上下文数据")}
            </span>
          </div>
        </Col>
      </Row>
    );
    let inputArr = (
      <div className="ant-search-custom">
        <Input
          style={null}
          key="theInput"
          addonAfter={
            <div style={{ cursor: "pointer" }}>
              <i
                onClick={this.showModal.bind(this)}
                className="anticon anticon-search"
              />
            </div>
          }
          value={typeof value === "undefined" ? "" : name}
        />
      </div>
    );
    if (!!type) {
      inputArr = (
        <WeaAssociativeSearch
          {...this.props}
          ref="associativeSearch"
          style={this.props.inputStyle}
          type={type}
          value={value}
          ids={paramKey}
          names={this.getSelectedId(name, false)}
          clickCallback={this.onBrowerClick}
          hasScroll={!noScroll}
          onChange={this.onBrowerChangeHandler}
        />
      );
    }
    let dom = inputArr;

    let footer = buttons || [
      <Button key="submit" type="primary" onClick={this.handleOk.bind(this)}>
        {getLabel(385565, "确 定")}
      </Button>,
      <Button key="clear" type="ghost" onClick={this.handleClear.bind(this)}>
        {getLabel(385566, "清 除")}
      </Button>,
      <Button key="back" type="ghost" onClick={this.handleCancel.bind(this)}>
        {getLabel(385567, "取 消")}
      </Button>
    ];
    return (
      <div>
        {dom}
        <input
          type="hidden"
          id={this.props.fieldName}
          name={this.props.fieldName}
          value={paramKey}
        />
        <Modal
          wrapClassName={`wea-browser-single ${
            showTop ? "" : "no-top"
          } wea-browser-modal wea-browser-table-cursor wea-nodetree-modal`}
          title={titleEle}
          zIndex={this.props.zIndex}
          width={modalStyle.width}
          // style={modalStyle}
          maskClosable={false}
          visible={visible}
          onCancel={this.handleCancel.bind(this)}
          footer={footer}
        >
          <Spin spinning={loading}>
            <div style={{ minHeight: 423 }}>
              {/*<div style={{minHeight: 440}}>*/}
              {/* {isList && this.renderList(hasPagination,contentType)}
                    {isTree && !this.state.noData && this.renderTree(hasPagination,contentType)} */}
              {this.renderSelect()}
              {this.renderData()}
            </div>
          </Spin>
        </Modal>
      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-node-tree-list/index.js